import { withGitpodSize } from "@/assets/icons/utils";
import { TASK_NAME } from "@/routes/ona-onboarding/onboarding-state";
import IconArrowSplit from "central-icons/IconArrowSplit";
import IconCircleDotted from "central-icons/IconCircleDotted";
import IconTestflight from "central-icons/IconTestflight";

export const PREDEFINED_TASKS = [
    {
        taskName: TASK_NAME.explainCodebase,
        Icon: withGitpodSize(IconCircleDotted),
        iconColor: "#0048FF",
        iconBackgroundColor: "#CAD7FA",
        title: "Explain the codebase",
        description: "What is the general structure, what's important to know?",
        prompt: "Analyze this codebase and explain its general structure, architecture, and key components. What are the most important things a developer should know to get started? Include information about the tech stack, main directories, entry points, and any critical patterns or conventions used.",
    },
    {
        taskName: TASK_NAME.fixBug,
        Icon: withGitpodSize(IconArrowSplit),
        iconColor: "#541500",
        iconBackgroundColor: "#FFDED4",
        title: "Fix a bug",
        description: "Find a bug in the codebase that looks important and fix it.",
        prompt: "Scan through the codebase to identify bugs that look important or impactful. Focus on issues that could affect functionality, performance, or user experience. Once you find a significant bug, create a new branch, implement a fix, write or update tests as needed, and commit the changes with a clear description.",
    },
    {
        taskName: TASK_NAME.boostTestCoverage,
        Icon: withGitpodSize(IconTestflight),
        iconColor: "#9800F0",
        iconBackgroundColor: "#EFD4FF",
        title: "Boost your test coverage",
        description: "Find key areas to cover with new and smarter tests.",
        prompt: "Identify ONE untested function in this project and write a single focused, useful unit test for it. Cover the main execution path and follow existing test patterns. Ensure the test passes.",
    },
] as const;

export type PredefinedTask = (typeof PREDEFINED_TASKS)[number];

export const PROMPT_TEMPLATE_SIZES = ["sm", "base", "lg"] as const;
